import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearHistoryStateAction } from '~/store/history/actions';
//import LoadingSpinner from "../components/common/LoadingSpinner"
import FooterTopBoxes from '~/components/common/FooterTopBoxes.js';
import Brands from '~/components/home/Brands';
import FiltersBanner from '~/components/home/FiltersBanner/FiltersBanner';
import GiftcardBanner from '~/components/home/GiftcardBanner';
import HeroSlider from '~/components/home/HeroSlider';
import PuzzleBanner from '~/components/home/PuzzleBanner';
import RecommendedProducts from '~/components/home/RecommendedProducts/RecommendedProducts';
import SalesProducts from '~/components/home/SalesProducts';
import SportsSlider from '~/components/home/SportsSlider';

import { useTranslation } from 'react-i18next';
import CouponPopup from '~/components/common/CouponPopup';
import FixedButtons from '~/components/common/FixedButtons';
import PageHeaderMeta from '~/components/common/PageHeaderMeta';
import DiscountCode from '~/components/home/DiscountCode';
import EspaBanner from '~/components/home/EspaBanner.js';

export default function Home() {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [showBanner, setShowBanner] = useState(true);

	useEffect(() => {
		dispatch(clearHistoryStateAction());

		var header_el = window.document.getElementsByTagName('header')[0];
		header_el.classList.add('home-header');

		window.onscroll = function () {
			if (document.documentElement.scrollTop > 0) {
				header_el.classList.remove('home-header');
			} else {
				if (!header_el.classList.contains('home-header')) {
					header_el.classList.add('home-header');
				}
			}
		};

		return () => {
			window.onscroll = null;
			header_el.classList.remove('home-header');
		};
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setShowBanner(false);
		}, 10000);
	}, []);

	return (
		<>
			<PageHeaderMeta page_title={t('sport_clothes')} meta_description={t('home_meta_description')} />

			<div id="main-wrapper home">
				<main id="homepage">
					{showBanner && <EspaBanner />}
					<HeroSlider />
					<PuzzleBanner />
					<SportsSlider />
					<Brands />
					<RecommendedProducts />
					<FiltersBanner />
					<GiftcardBanner />
					<SalesProducts />
					<DiscountCode />
					<FooterTopBoxes />
					<CouponPopup />
					<FixedButtons />
				</main>
			</div>
		</>
	);
}
